export default __webpack_public_path__ + "static/media/order-details.a1d0dd4a.png";